<template>
    <v-app>
        <AppAlert />
        <AppLoading />
        <AppNotification />
        <router-view />
    </v-app>
</template>

<script>

import AppAlert from "@/components/common/AppAlert";
import AppLoading from "@/components/common/AppLoading";
import AppNotification from "@/components/common/AppNotification";

export default {
  components: {
    AppAlert,
    AppLoading,
    AppNotification,
  },
  created() {
    // The organisation identity is public (the login page shows it), so it is loaded once here,
    // before sign-in. The load is silent and always resolves, falling back to the generic name.
    this.$store.dispatch("organization/load").then(this.applyOrganizationIdentity);
  },
  methods: {
    // The browser tab shows the organisation name and, when there is one, its logo as the icon.
    applyOrganizationIdentity() {
      document.title = this.$store.getters["organization/displayName"];

      const logoUrl = this.$store.getters["organization/logoUrl"];
      if (!logoUrl) return;

      let icon = document.querySelector("link[rel~='icon']");
      if (!icon) {
        icon = document.createElement("link");
        icon.rel = "icon";
        document.head.appendChild(icon);
      }
      icon.href = logoUrl;
    },
  },
};
</script>
